var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactIconBig({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    fill: "#EDEEEE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_4193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9167 25.7104C30.9162 27.1349 30.4293 28.5166 29.5365 29.6267C28.6437 30.7367 27.3986 31.5086 26.0073 31.8146L25.3427 29.8208C25.9513 29.7206 26.5301 29.4866 27.0373 29.1357C27.5445 28.7848 27.9676 28.3258 28.2761 27.7916H25.7083C25.1558 27.7916 24.6259 27.5722 24.2352 27.1815C23.8445 26.7908 23.625 26.2608 23.625 25.7083V21.5416C23.625 20.9891 23.8445 20.4592 24.2352 20.0685C24.6259 19.6778 25.1558 19.4583 25.7083 19.4583H28.7688C28.5146 17.4447 27.5343 15.593 26.0119 14.2507C24.4895 12.9084 22.5296 12.1678 20.5 12.1678C18.4704 12.1678 16.5105 12.9084 14.9881 14.2507C13.4657 15.593 12.4855 17.4447 12.2313 19.4583H15.2917C15.8442 19.4583 16.3741 19.6778 16.7648 20.0685C17.1555 20.4592 17.375 20.9891 17.375 21.5416V25.7083C17.375 26.2608 17.1555 26.7908 16.7648 27.1815C16.3741 27.5722 15.8442 27.7916 15.2917 27.7916H12.1667C11.6141 27.7916 11.0842 27.5722 10.6935 27.1815C10.3028 26.7908 10.0833 26.2608 10.0833 25.7083V20.5C10.0833 14.7469 14.7469 10.0833 20.5 10.0833C26.2531 10.0833 30.9167 14.7469 30.9167 20.5V25.7104Z",
    fill: "#8E8F8F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_4193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIconBig);
export default __webpack_public_path__ + "static/media/ContactIconBig.3cffa62d69de34d8d516ce5556ffc292.svg";
export { ForwardRef as ReactComponent };